module.exports = __webpack_public_path__ + "static/img/bg.bd11906a.png";